<template>
  <div v-bind:class="['ssws-item-section']">
    <a
      class="iteml-section"
      :href="item.permalink"
      :target="target == 'blank' ? '_blank' : ''"
      :aria-labelledby="'heading-level_' + item.post_date"
    >
      <div class="left-sec">
        <div class="img-sec">
          <div
            class="ssws_is-new nytidaimg"
            v-if="item.metadata['ssws_is-new'] == true"
          >
            <span> {{ item.metadata['ssws_date-of-opening'] }}</span>
          </div>

          <div v-if="item.images.medium">
            <img :src="item.images.medium.url" :alt="item.post_title" />
          </div>
        </div>
        <div
          class="location-sec"
          v-if="
            !isProtectedService &&
            item.metadata &&
            item.metadata.ssws_location &&
            item.metadata.ssws_location.address
          "
        >
          <span class="map-locator">
            <svg
              enable-background="new 0 0 362.3 362.3"
              version="1.1"
              viewBox="0 0 362.3 362.3"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="m181.15 0c-76.855 0-139.38 62.528-139.38 139.38 0 72.646 115.69 197.71 128.88 211.75l10.502 11.163 10.502-11.163c13.193-14.027 128.88-139.11 128.88-211.75 6e-3 -76.856-62.522-139.38-139.38-139.38zm0 197.06c-31.801 0-57.676-25.875-57.676-57.676 0-31.802 25.875-57.676 57.676-57.676 31.808 0 57.676 25.875 57.676 57.676 0 31.802-25.868 57.676-57.676 57.676z"
              />
            </svg>
          </span>
          <div
            id="location"
            v-html="computeLocation(item.metadata.ssws_location.address)"
          ></div>
        </div>
      </div>
      <div class="content-sec">
        <p class="categ" v-if="item.taxonomies['Tjänst']">
          <span
            class="item"
            v-for="(tjanst, idx) in item.taxonomies['Tjänst']"
            :key="idx"
          >
            {{ tjanst
            }}<span v-if="idx + 1 < item.taxonomies['Tjänst'].length">, </span>
          </span>
        </p>
        <h3 class="item-title h3style" :id="'heading-level_' + item.post_date">
          <ais-highlight :hit="item" attribute="post_title" />
        </h3>
        <span
          class="Samverkan-f1"
          v-for="(Samverkan, idx2) in item.taxonomies['Samverkan']"
          :key="idx2"
        >
          {{ Samverkan }}
        </span>
        <p class="group" v-if="item.taxonomies.Målgrupp">
          <strong>{{ copy.targetGroup }}: </strong>
          <span
            class="item"
            v-for="(Målgrupp, idx) in item.taxonomies['Målgrupp']"
            :key="idx"
          >
            <span v-html="Målgrupp"></span>
            <span v-if="idx + 1 < item.taxonomies['Målgrupp'].length">, </span>
          </span>
        </p>

        <p class="address" v-if="item.metadata['ssws_age-span']">
          <strong>{{ copy.ageRange }}: </strong>
          {{ item.metadata['ssws_age-span'] }}
        </p>
        <!-- <p class="diagnoses" v-if="item.taxonomies['Diagnos/specialiteter']">
        <strong>{{ copy.diagnosTitle }}: </strong>
        <span
          class="item"
          v-for="(Diagnos, idx) in item.taxonomies['Diagnos/specialiteter']"
          :key="idx"
        >
          {{ Diagnos
          }}<span
            v-if="idx + 1 < item.taxonomies['Diagnos/specialiteter'].length"
            >,
          </span>
        </span>
      </p>-->
        <p class="lagrum" v-if="item.taxonomies['Lagrum']">
          <strong>{{ copy.storageSpace }}: </strong>
          <span
            class="item"
            v-for="(Lagrum, idx) in item.taxonomies['Lagrum']"
            :key="idx"
          >
            {{ Lagrum
            }}<span v-if="idx + 1 < item.taxonomies['Lagrum'].length">, </span>
          </span>
        </p>
        <p class="plaster" v-if="item.metadata['ssws_antal-platser']">
          <strong>{{ copy.numOfSeats }}: </strong>
          {{ item.metadata['ssws_antal-platser'] }}
        </p>
        <p class="person-kit" v-if="item.taxonomies['Personkrets inom LSS']">
          <strong>{{ copy.circleOfPersons }}: </strong>
          <span
            class="item"
            v-for="(Personkrets, idx) in item.taxonomies[
              'Personkrets inom LSS'
            ]"
            :key="idx"
          >
            {{ Personkrets
            }}<span
              v-if="idx + 1 < item.taxonomies['Personkrets inom LSS'].length"
              >,
            </span>
          </span>
        </p>

        <p class="read-more" :href="item.permalink">
          {{ copy.itemsReadmoreText }}
        </p>
      </div>
    </a>
    <div class="right-sec">
      <span class="the-chef" v-if="item.metadata['ssws_ec-namn']">
        <span v-if="item.metadata['ssws_ec-alternative-title']">
          {{ item.metadata['ssws_ec-alternative-title'].toLowerCase() }}
        </span>
        <span
          v-else-if="
            item.taxonomies['Segment'] &&
            item.taxonomies['Segment'].includes('Skola')
          "
        >
          {{ copy.operationalManagerSkola.toLowerCase() }}
        </span>
        <span v-else> {{ copy.operationalManager.toLowerCase() }} </span>
        <span class="right-title"> {{ item.metadata['ssws_ec-namn'] }} </span>
      </span>
      <div class="info-sec">
        <p class="tel" v-if="item.metadata['ssws_ec-tel']">
          {{ copy.telTitle }}:
          <span
            class="text-green"
            v-html="wrapPhones(item.metadata['ssws_ec-tel'])"
          ></span>
        </p>
        <p class="e-post" v-if="item.metadata['ssws_ec-mail']">
          {{ copy.mailTitle }}:
          <span class="text-green"
            ><a :href="`mailto:${item.metadata['ssws_ec-mail']}`">{{
              item.metadata['ssws_ec-mail']
            }}</a></span
          >
        </p>
      </div>
      <span
        class="address"
        v-if="
          item.metadata &&
          item.metadata.ssws_location &&
          item.metadata.ssws_location.address
        "
      >
        <span class="address-title">{{ copy.visitingAddress }}</span>
        <span
          v-html="computeAddressString(item.metadata.ssws_location.address)"
        >
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    isProtectedService() {
      return (
        this.item &&
        this.item.taxonomies &&
        this.item.taxonomies['Tjänst'] &&
        this.item.taxonomies['Tjänst'].includes('Skyddat boende')
      );
    },
  },
  props: {
    item: Object,
    copy: Object,
    target: String,
    index: Number,
  },
  methods: {
    computeAddressString(addressObj) {
      var address = '';

      if (
        typeof addressObj.street !== 'undefined' &&
        addressObj.street !== ''
      ) {
        address += addressObj.street + '<br>';
      }

      // For protected accommodation on Nytida, show only the street address.
      // Do not show postcode or city.
      if (this.isProtectedService) {
        return address.trim();
      }

      if (typeof addressObj.zip !== 'undefined' && addressObj.zip !== '') {
        let addzip = addressObj.zip;
        let addzipspaced = addzip.match(/.{1,3}/g);
        let zip_with_space = addzipspaced.join(' ');
        address += zip_with_space + ' ';
      }

      if (address !== '') {
        if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
          address += addressObj.city + ' ';
        }
        return address.trim();
      }

      if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
        return addressObj.city.trim();
      }

      if (
        typeof addressObj.municipality !== 'undefined' &&
        addressObj.municipality !== ''
      ) {
        return addressObj.municipality.trim();
      }

      if (
        typeof addressObj.region !== 'undefined' &&
        addressObj.region !== ''
      ) {
        return addressObj.region.trim();
      }

      return '';
    },
    wrapPhones(text) {
      text = text.replace(/[\u2010-\u2015\u2212]/g, '-');
      return text.replace(
        /\+?\d[\d -]{4,20}\d/g,
        (phone) => `<a href="tel:${phone.replace(/[\s-]/g, '')}">${phone}</a>`
      );
    },
    computeLocation(address) {
      var location = '';

      if (typeof address.city !== 'undefined' && address.city !== '') {
        location += address.city;
      }

      if (
        typeof address.municipality !== 'undefined' &&
        address.municipality !== ''
      ) {
        if (
          location !== '' &&
          location.trim().toUpperCase() !==
            address.municipality.trim().toUpperCase()
        ) {
          location += ', ' + address.municipality;
        } else {
          location = address.municipality;
        }
      }

      if (typeof address.region !== 'undefined' && address.region !== '') {
        if (location === '') {
          return address.region;
        } else {
          var municipality = '';
          if (typeof address.municipality !== 'undefined') {
            municipality = address.municipality;
          }

          if (
            address.region.trim().toUpperCase() !==
            municipality.trim().toUpperCase()
          ) {
            location += ', ' + address.region;
          } else {
            return location;
          }
        }
      }

      return location;
    },
  },
};
</script>
<style>
a.remove_underline_2 {
  text-decoration: none !important;
  color: #000 !important;
}
.ssws-item-section .left-sec {
  padding: 30px;
  width: 25%;
  max-width: 220px;
}
.ssws-item-section .content-sec {
  width: 50%;
  padding: 30px;
}
.ssws-item-section .right-sec {
  width: 30%;
  padding: 30px;
}
a.descption_f {
  text-decoration: none !important;
  color: #000 !important;
}
span.Samverkan-f1 {
  background: #9c9c9b;
  padding: 3px 20px;
  margin: 10px 10px 10px 0px !important;
  color: #fff;
  font-size: 14px;
  display: inline-block;
}
.ssws-item-section {
  display: flex;
  margin-bottom: 1rem;
  border: 1px solid #c4c8d8;
  box-shadow: 0 2px 5px 0 #e3e5ec;
}

.ssws-item-section.hidden {
  display: none;
}

.ssws-item-section .img-sec img {
  height: 150px;
  width: 150px;
  object-fit: cover;
}

.ssws-item-section .search-more-item-wrap .hidden {
  display: none !important;
}

.ssws-item-section span.map-locator {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.ssws-item-section .location-sec {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.h3style {
  display: block;
  font-size: 1.5em;
  margin-top: 0.83em;
  margin-bottom: 10px;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

.ssws-item-section .right-sec {
  border-radius: 0 0 0 32px !important;
}

.search-panel__results .ais-InfiniteHits-item a.iteml-section {
  position: relative;
}
.search-panel__results .ais-InfiniteHits-item a.iteml-section:focus-visible {
  outline: 3px solid #a800c3 !important;
}
.map-wrapper button:focus,
.map-wrapper button:focus-within,
.map-wrapper button:focus-visible {
  outline: 3px solid #a800c3 !important;
}
.ssws-item-section .left-sec,
.ssws-item-section .content-sec {
  padding: 0px !important;
}
.nytidaimg {
  background-color: #376b2d !important;
  top: 0;
  color: #fff;
  left: 0;
  padding: 9px 16px;
  font-family: BrownLLWeb-Regular;
  font-weight: 400 !important;
  position: absolute;
  width: auto;
  font-size: 16px !important;
}

@media (max-width: 991px) {
  .ssws-item-section .left-sec,
  .ssws-item-section .content-sec {
    width: 50%;
    max-width: 100%;
  }
  .ssws-item-section .right-sec {
    display: none;
  }
  .ssws-item-section .img-sec img {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 767px) {
  .ssws-item-section .left-sec,
  .ssws-item-section .content-sec {
    width: 100%;
  }
  .ssws-item-section .ssws-item-section {
    flex-direction: column;
  }
}
</style>
